import { Alert } from 'antd'
import Dragger from 'antd/es/upload/Dragger'
import styled from 'styled-components'

import { ColorToken } from '../constants/theme/types'

import { StylePropsMobile, getLightContainerStyleProps } from './shared/StyledComponents'

interface Props {
  $margin?: string
  $notWidth100?: boolean
  $colorToken?: ColorToken
}
// negative margins -> do not include width: 100%;
export const HorizontalLine = styled.div<Props>`
  ${(props) => (props.$margin?.includes('-') || props.$notWidth100 ? '' : 'width: 100%')};
  background-color: ${(props) =>
    props.$colorToken ? props.theme[props.$colorToken as string] : props.theme.colorSplit};
  height: 1px;
  ${(props) => (props.$margin ? `margin: ${props.$margin};` : '')};
`

export interface StyledDraggerProps {
  $asChild?: boolean
  $disabled?: boolean
  $error?: boolean
}

export const StyledDragger = styled(Dragger)<StyledDraggerProps>`
  .ant-upload-list {
    display: none;
  }
  ${({ $asChild, $disabled, $error, theme }) =>
    $asChild
      ? `
      .ant-upload {
        padding: 0 !important;
        border: none !important;
      }
      `
      : `
      .ant-upload-drag {
        ${getLightContainerStyleProps(theme, $error)}
      }
      .ant-upload {
        padding: 8px !important;
        text-align: unset;
        &:hover {
          ${$disabled && `border-color: ${theme.colorBorder};`}
        }
      }
      width: 100%;
`}
`

export const StyledDraggerContentContainer = styled.div<StylePropsMobile>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$small ? '8px' : '15px')};
  align-items: center;
  justify-content: center;
  position: relative;
`

export const NeutralAlert = styled(Alert)`
  ${({ theme }) => `
    background-color: ${theme.colorFillAlter};
    border: solid 1px ${theme.colorBorder};
    padding: 8px 16px;
`}
`
